<template>
	<div class="b-basketBtn" :class="blockClass">
		<template v-if="inBasket">
			<a :href="basketUrl"
			   class="b-basketBtn__link b-basketBtn__link_inBasket no-underline"
			   :class="{'loading': true === loading}">
				<span class="icon icon--check b-basketBtn__linkIcon b-basketBtn__linkIcon_inBasket"></span>
				<span class="b-basketBtn__title" v-html="loc.CITRUS_VUE_PRODUCT_BASKET_BUTTON_IN_BASKET"></span>
			</a>
			<a v-if="true === showMobile"
			   :href="basketUrl"
			   class="b-basketBtn__link b-basketBtn__link_inBasket no-underline _mobile"
			   :class="{'loading': true === loading}"
			   :title="loc.CITRUS_VUE_PRODUCT_BASKET_BUTTON_IN_BASKET"
			>
				<span class="icon icon--check b-basketBtn__linkIcon b-basketBtn__linkIcon_inBasket"></span>
			</a>
		</template>
		<template v-else>
			<a :href="detailUrl"
			   class="b-basketBtn__link b-basketBtn__link_toBasket no-underline"
			   :class="{'loading': true === loading}"
			   @click="onBasketClick"
			>
				<span class="icon icon--basket b-basketBtn__linkIcon b-basketBtn__linkIcon_toBasket"></span>
				<span class="b-btn b-btn_primary b-btn_small b-basketBtn__title" v-html="basketBtnText" :class="{'b-btn_loading': loading}"></span>
			</a>
			<a v-if="true === showMobile"
			   :href="detailUrl"
			   class="b-basketBtn__link b-basketBtn__link_toBasket no-underline _mobile"
			   :class="{'loading': true === loading}"
			   @click="onBasketClick"
			   :title="basketBtnText"
			>
				<span class="icon icon--basket b-basketBtn__linkIcon b-basketBtn__linkIcon_toBasket"></span>
			</a>
		</template>
	</div>
</template>
<script>
	import {Vue} from "ui.vue";
	import {store} from "citrus.vuex.store";

	/**
	 * Дефолтные параметры данных продукта
	 *
	 * available - товар доступен
	 * can_buy - товар можно купить
	 * currency - валюта цены товара
	 * full - базовая цена на товар без скидок
	 * in_basket - товар в корзине
	 * price - цена с учетом скидок
	 */
	export const defaultPriceData = {
		available: true,
		can_buy: true,
		currency: 'RUB',
		full: 0,
		in_basket: false,
		price: 0
	};

	export default {
		name: 'CitrusProductBasketButton',
		/**
		 * productId - идентификатор товара
		 * price - данные о цене
		 * showMobile - показывать доп.контент для мобильных устройств
		 * bindGlobalBasket - отправлять глобальные события
		 * basketUrl - ссылка на корзину
		 * hasSku - у товара есть торговые предложения
		 * storageType - код хранилища данных
		 * customText - свой текст для кнопки
		 */
		props: {
			productId: [Number, String],
			price: Object,
			blockClass: {
				type: String,
				required: false,
				default: ''
			},
			detailUrl: {
				type: String,
				required: false,
				default: ''
			},
			basketUrl: {
				type: String,
				required: false,
				default: '/order/'
			},
			showMobile: {
				type: Boolean,
				required: false,
				default: false
			},
			bindGlobalBasket: {
				type: Boolean,
				required: false,
				default: true
			},
			hasSku: {
				type: Boolean,
				required: false,
				default: false
			},
			storageType: {
				type: [String, Boolean],
				required: false,
				default: false
			},
			customText: {
				type: String,
				required: false,
				default: ""
			},
			/** количество для добавления в корзину */
			quantity: {
				type: Number,
				default: 1
			},
			metricGoal: {
				type: [Boolean, String],
				default: false
			},
			canOrder: {
				type: Boolean,
				required: false,
				default: true
			},
		},

		/**
		 * Подключение хранилища данных
		 */
		store,

		/**
		 * Изменяемые данные
		 *
		 * @return {Object}
		 */
		data() {
			return {
				priceData: defaultPriceData,
			};
		},

		watch: {
			price: {
				handler(newVal) {
					this.priceData = this.preparePriceData(newVal);
				},
				deep: true
			}
		},

		created() {
			this.priceData = this.preparePriceData(this.price);

			Vue.event.$on("Citrus.Vue.Product:addedToBasket:" + this.productId, this.onAfterAdd);
			Vue.event.$on("Citrus.Vue.Product:removedFromBasket:" + this.productId, this.onAfterRemove);

			if (this.bindGlobalBasket) {
				//BX.addCustomEvent("Citrus.Vue.Product:removedBasket", this.onAfterRemove);
			}
		},

		beforeDestroy() {
			Vue.event.$off("Citrus.Vue.Product:addedToBasket:" + this.productId, this.onAfterAdd);
			Vue.event.$off("Citrus.Vue.Product:removedFromBasket+" + this.productId, this.onAfterRemove);
		},

		computed: {

			/**
			 * Языковые фразы
			 *
			 * @return {ReadonlyArray<any>}
			 */
			loc() {
				return Vue.getFilteredPhrases("CITRUS_VUE_PRODUCT_BASKET_BUTTON_");
			},

			/**
			 * Лежит ли товар в корзине
			 *
			 * @return {Boolean}
			 */
			inBasket() {
				let inBasket = false;
				switch (this.storageType) {
					case 'vuex':
						inBasket = this.$store.getters['basket/check'](this.productId);
						break;
					case 'input':
						inBasket = true === this.priceData.in_basket;
						break;
					default:
						inBasket = false;
				}

				return inBasket;
			},

			basketBtnText() {
				if (this.customText.length > 0) {
					return this.customText;
				}

				if (this.priceData.price <= 0) {
					return (this.canOrder)
						? this.loc['CITRUS_VUE_PRODUCT_BASKET_BUTTON_PREORDER']
						: this.loc['CITRUS_VUE_PRODUCT_BASKET_BUTTON_SHOW_DETAIL_PAGE'];
				}

				return (
					this.canAddToBasket()
						? this.loc['CITRUS_VUE_PRODUCT_BASKET_BUTTON_ADD_TO_BASKET']
						: ((this.canOrder)
							? this.loc['CITRUS_VUE_PRODUCT_BASKET_BUTTON_PREORDER']
							: this.loc['CITRUS_VUE_PRODUCT_BASKET_BUTTON_SHOW_DETAIL_PAGE']
						)
				);
			},
			loading() {
				if (this.storageType == 'vuex') {
					return this.$store.getters['basket/loading'](this.productId);
				}

				return false;
			}
		},

		methods: {

			/**
			 * Подготовка и перепроверка входных данных о товаре
			 *
			 * @param data
			 * @return {Object}
			 */
			preparePriceData(data) {
				if (typeof data !== 'object' || data === null) {
					return defaultPriceData;
				}

				let code, result = {};
				for (code in defaultPriceData) {
					if (!data.hasOwnProperty(code)) {
						result[code] = defaultPriceData[code];
						continue;
					}
					switch (typeof defaultPriceData[code]) {
						case "boolean":
							result[code] = (true === data[code] || 'true' === data[code]);
							break;
						case "string":
							result[code] = String(data[code]).trim();
							break;
						case "number":
						case "bigint":
							result[code] = Number(data[code]);
							break;
						case "object":
							result[code] = (data[code] !== null) ? data[code] : {};
							break;
						default:
							result[code] = defaultPriceData[code];
							break;
					}
				}

				return result;
			},

			/**
			 * Действия для добавления товара в корзину
			 * Изменяется содержимое хранилища о товарах в корзине и пробрасываются события об изменении корзины
			 */
			sendAdd() {
				switch (this.storageType) {
					case 'vuex':
						this.$store.dispatch('basket/add', {id: this.productId, quantity: this.quantity});
						break;
					default:
						this.priceData.in_basket = true;
						Vue.event.$emit("Citrus.Vue.Product:addedToBasket:" + this.productId, {
							basketItem: this.basketItem,
							name: "bx-catalog-product-buy"
						});

						BX.onCustomEvent("OnBasketChange");
				}

				// отправим данные по метрике
				if(this.metricGoal)
				{
					this.$gtag.event(this.metricGoal);
					this.$metrika.reachGoal(this.metricGoal);
				}
			},

			onAfterAdd(params) {
				if (true !== this.priceData.in_basket) {
					this.priceData.in_basket = true;
				}
				if (true !== this.priceData.can_buy) {
					this.priceData.can_buy = true;
				}
				if (params.hasOwnProperty("basketItem") && params.basketItem) {
					this.basketItem = params.basketItem;
				} else {
					this.basketItem = 0;
				}
			},

			/**
			 * Обработка действий после
			 */
			onAfterRemove() {
				if (true === this.priceData.in_basket) {
					this.priceData.in_basket = false;
				}

				this.basketItem = 0;
			},

			/**
			 * Клик по кнопке `Купить/Заказать`
			 *
			 * @param e
			 */
			onBasketClick(e) {
				if (!this.canAddToBasket()) {
					if (this.canOrder) {
						if (e) e.preventDefault();
						BX.onCustomEvent("PreorderButton:click", [this.productId, this.priceData.price, this.priceData.full, this.detailUrl]);
					}
					return;
				}

				if (e) e.preventDefault();

				this.sendAdd();
			},
			canAddToBasket() {
				return this.priceData.can_buy && this.productId > 0 && !this.hasSku && this.priceData.price > 0;
			}
		}
	};
</script>